import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export async function getGroceryData(householdId) {
  const snap = await getDoc(doc(db, "groceryChecked", householdId));
  if (!snap.exists()) return null;
  return {
    checked:     snap.data().checked     || {},
    customItems: snap.data().customItems || [],
  };
}

export async function saveGroceryData(householdId, checked, customItems) {
  await setDoc(doc(db, "groceryChecked", householdId), { checked, customItems });
}

export function generateGroceryList(weekPlan) {
  const grocery = {};

  weekPlan.forEach(day => {
    day.meals?.forEach(meal => {
      meal.ingredients?.forEach(item => {
        if (!grocery[item]) {
          grocery[item] = 1;
        } else {
          grocery[item] += 1;
        }
      });
    });
  });

  return Object.entries(grocery).map(([name, qty]) => ({
    name,
    qty
  }));
}